export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives14.0765e204.jpg";